import request from "@/utils/request.js";

// 新增网站参数
export function getWebsiteInfo() {
    return request({
        url: "/website/set/getWebsiteInfo",
        method: "get",
    });
}
